// TODO - Do we need this?
export const serialize = <TItem>(item: TItem): string | null => {
    let serialized = null;
    try {
        serialized = JSON.stringify(item);
    } catch (error) {
        console.info(error);
    }
    return serialized;
};
